<template>
    <v-dialog
        v-model="$store.state.tracking.editProduct"
        width="700px"
        persistent
        transition="dialog-transition"
    >
        <v-card>
            <v-toolbar color="primary" dense>
                <v-spacer></v-spacer>
                <v-toolbar-title class="white--text"
                    >{{prm.Station}}</v-toolbar-title
                >
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    dark
                    @click="$store.state.tracking.editProduct = false"
                    ><v-icon>mdi-close</v-icon></v-btn
                >
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-simple-table dense>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th v-if="prm.Station[0]+prm.Station[1] == 'CK'">Dropped</th>
                                <th class="text-left">Product</th>
                                <th class="text-left">Order QTY</th>
                                <th>Dispatched QTY</th>
                                <th v-if="prm.Station[0]+prm.Station[1] == 'CK'">Diff</th>
                                <th>OrderID#</th>
                                <th width="20%">No Allocation</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, j) in data" :key="j">
                                <template v-if="prm.Station[0]+prm.Station[1] == 'CK'">
                                    <td v-if="item.hasCKDropped">
                                        <v-icon color="success">mdi-check-circle</v-icon>
                                    </td>
                                    <td v-else>
                                        <v-icon>mdi-close-circle</v-icon>
                                    </td>
                                </template>
                                <td>
                                    {{ item.Product }}
                                </td>
                                <td>
                                    {{ item.Quantity }}
                                </td>
                                <td>
                                    <v-text-field
                                        v-model="item.DispatchedQuantity"        
                                        @input="comparateData(item)"
                                        @change="diffs"
                                        dense
                                        hide-details
                                        v-if="prm.Station[0]+prm.Station[1] == 'CK'"
                                    ></v-text-field>
                                    <v-text-field
                                        v-model="item.DispatchedQuantity"    
                                        dense
                                        hide-details
                                        v-else
                                    ></v-text-field>
                                </td>
                                <td v-if="prm.Station[0]+prm.Station[1] == 'CK'">{{ item.diff }}</td>
                                <td>
                                    {{ item.OrderID }}
                                </td>
                                 <td>
                                    <v-checkbox  v-model="item.hasNoAllocation" :value="item.hasNoAllocation" 
                                        hide-details dense></v-checkbox>
                                </td> 
                            </tr>
                            <tr  v-if="prm.Station[0]+prm.Station[1] == 'CK'">
                                <td class="text-right" colspan="4">
                                    Total Diff:
                                </td>
                                <td>{{ prm.Diff }}</td>
                                <td colspan="2"></td>
                            </tr>
                            <tr  v-if="prm.Station[0]+prm.Station[1] == 'CK'">
                                <td>Justify:</td>
                                <td colspan="7" >
                                    <v-text-field
                                        v-model="prm.Justify"
                                        dense
                                        hide-details
                                    ></v-text-field>
                                </td>
                                
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
                <v-row>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="saveModal()" class="ma-4"
                        >Save</v-btn
                    >
                </v-row>
            </v-container>
        </v-card>
        
        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
    </v-dialog>
</template>
<script>
import axios from 'axios';
import ConfirmDialogue from './../../ConfirmDialogue.vue';
export default {
    props: ['prm','idx'],
    components:{  
        ConfirmDialogue
    },
    data: function() {
        return {
            orderID: '',
            data: [],
            origin:[],
            diffT:null,
            justifyT: ''
        };
    },
   async mounted ()  {
    console.log(this.prm.Station[0]+this.prm.Station[1]);
       this.loadOrderDetails(this.prm.OrderID)
    },
    methods: {
        loadOrderDetails: function(orderID) { 
            var str = this.$store;
            console.log(orderID);
            axios
                    .get('order-detail/order/'+orderID, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        console.log(response.data.data);
                        response.data.data.forEach(element => {
                            element.diff = element.Quantity - element.DispatchedQuantity;
                        });
                        this.data= response.data.data;
                        this.origin= response.data.data;
                    })
                    .catch(function(error) {
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                    });
        },

        comparateData: function(itm){
            itm.diff = 0;
           if(itm.DispatchedQuantity != itm.Quantity){
             itm.hasCKDropped = 1;
              itm.diff = itm.Quantity - itm.DispatchedQuantity;
           }else{
            this.confirmSameQuantity(itm);
           }
        },
        async confirmSameQuantity(itm) {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'Quantity and DispatchedQuantity is the same',
                message: 'Dropped?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                itm.hasCKDropped = 1;
            }else {
                itm.hasCKDropped = 0;
            }
        },
        saveModal:async function() {
            console.log(this.data);
            var noAllo = 0; 
            await this.data.forEach(element => {
                if(element.hasNoAllocation == 1){
                    noAllo =  1;
                };
            });
            console.log(noAllo);
                var params = {};
                if(this.prm.Station[0]+this.prm.Station[1] == 'CK'){
                    params ={
                        NoAllocation: noAllo,
                        Justify:this.prm.Justify,
                        Diff:this.prm.Diff,
                    }
                }else{
                    params = {
                        NoAllocation: noAllo,
                    }
                }
                
                var str = this.$store;
                axios
                    .put('order/' + this.prm.OrderID, params, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    // eslint-disable-next-line no-unused-vars
                    .then(async response => {
                        this.$store.dispatch('setSnackbar', {
                            color: 'success',
                            text: 'Successfully updated.'
                        });
                    })
                    .catch(error => {
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                        console.log(error);
                    });
             this.saveOrderDetail(this.data);
           
        },
        diffs:async function() {
            this.prm.Diff = 0;
            this.data.forEach(product => {
                if (
                    product.hasNoAllocation === true ||
                    product.hasNoAllocation === 1
                ) {
                    product.DispatchedQuantity = 0;
                }
                console.log(product.diff)
                this.prm.Diff = product.diff +this.prm.Diff;
            });
            this.prm.Justify =
            this.prm.Diff < 0
                    ? 'It is not Short'
                    : this.prm.Diff < 600
                    ? 'Short due last residues'
                    : this.prm.Diff < 1300
                    ? 'Short not identified, check density and temperature against BOL and Appendix'
                    : this.justifyT;
            console.log('-------------', this.prm.Diff, this.justifyT);
        },
        saveOrderDetail: function(params) {
            var str = this.$store;
                var prms = {
                    orders : params,
                };
                console.log('order-detail/save/multiples', prms);
            axios
                    .put('order-detail/save/multiples', prms, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        console.log(response);
                         str.dispatch('setSnackbar', {
                                color: 'success',
                                text:'Save  successful'
                            });  
                        this.$store.state.tracking.watch = this.idx;
                    })
                    .catch(function(error) {
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                    });
        }
    }
};
</script>
